import Api from './Api';

class _StatsApi extends Api {
    loadAppStats(): Promise<any> {
        return this.getLocalHttpClient(false).get('stats');
    }

    recalculateTop30(): Promise<any> {
        return this.getLocalHttpClient(true).get('admin/order/stats');
    }

    incrementVoice(file: string): Promise<any> {
        return this.getLocalHttpClient(true).post('rating/increment', {
            file: file,
        });
    }
}

export const StatsApi = new _StatsApi();
